import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import AppSidebar from './AppSidebar';
import { AppShellProvider } from './AppShellContext';
import { CONTENT_PADDING, getRouteMeta } from './routeConfig';

function AppShellContent() {
  const location = useLocation();
  const routeMeta = getRouteMeta(location.pathname);
  const paddingKey = routeMeta.contentPadding || 'standard';
  const paddingSx =
    paddingKey === 'none'
      ? { p: 0 }
      : CONTENT_PADDING[paddingKey] || CONTENT_PADDING.standard;

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        bgcolor: 'var(--color-bg-default)',
      }}
    >
      <AppSidebar />
      <Box
        component="main"
        sx={{
          flex: '1 1 0',
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          ...paddingSx,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: routeMeta.fullHeight ? 'hidden' : 'auto',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default function AppShellLayout() {
  return (
    <AppShellProvider>
      <AppShellContent />
    </AppShellProvider>
  );
}
